import React from 'react'
import GenerateHtml from '../generateHtml'

const Buckley = () => {
    return (
        <div>
            < GenerateHtml 
            reviewsColor= "#f69062"
            styles="max-width: 70%; "
            displayingHtmlFor = "Buckley"
            />
        </div>
    )
}

export default Buckley
